import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import ToastMessage from "../../ToastMessage";
import ConfirmModal from "../../ConfirmModal";
import {
  getToimenpiteetByForeignKey,
  patchToimenpideKategoria,
  patchToimenpideAlakategoria,
  patchToimenpideMerkittava,
  patchToimenpideValiton,
  patchToimenpideContent,
  deleteToimenpide,
  createToimenpide
} from "../../../api/api";
import { TOIMENPIDE_CATEGORIES } from "../../utils/toimenpideCategories";

const EMPTY_SECTION = "__NONE__";

export default function ToimenpiteetBlock({ data = {}, onChange, blockPath = [], mode = "report" }) {
  const { id:kiinteisto_id,reportId: report_id } = useParams();
  const mainCategories = Object.keys(TOIMENPIDE_CATEGORIES || []);
  const [category, setCategory] = useState(data?.category || "");
  const [subCategory, setSubCategory] = useState(data?.subCategory || null);
  const [items, setItems] = useState([]);
  const [toast, setToast] = useState({ show: false, message: "", bg: "success" });
  const [confirmModal, setConfirmModal] = useState({ show: false, rowIndex: null });

  const subCategories = category && TOIMENPIDE_CATEGORIES[category] ? TOIMENPIDE_CATEGORIES[category] : [];

  const fetchToimenpiteet = async () => {
    try {
      const res = await getToimenpiteetByForeignKey(
        "report_id",
        report_id,
        category || null,
        subCategory || null
      );
      setItems(res.data || []);
    } catch (err) {
      console.error(err);
      setToast({
        show: true,
        message: err.response?.data?.error || "Virhe haettaessa toimenpiteitä",
        bg: "danger",
      });
    }
  };

  useEffect(() => {
    fetchToimenpiteet();
  }, [category, subCategory, report_id]);

  const updateMainCategory = async (fieldCategoryValue) =>{
    setCategory(fieldCategoryValue)
    try{
      onChange?.({ ...data, category: fieldCategoryValue });
    }catch(err){
      console.error('Update updateMainCategory failed with error', err)
    }
  }
  const updateMainSubcategory = async (fieldSubcategoryValue) =>{
    setSubCategory(fieldSubcategoryValue)
    try{
      onChange?.({ ...data, subCategory: fieldSubcategoryValue });
    }catch(err){
      console.error('Update updateMainSubcategory failed with error', err)
    }
  }

  const updateItemField = async (idx, field, value) => {
    const row = items[idx];
    const patchMap = {
      kategoria: patchToimenpideKategoria,
      alakategoria: patchToimenpideAlakategoria,
      merkittava: patchToimenpideMerkittava,
      valiton: patchToimenpideValiton,
      content: patchToimenpideContent,
    };
    try {
      if (patchMap[field]) {
        await patchMap[field](row.id, value);
        const next = items.map((it, i) => (i === idx ? { ...it, [field]: value } : it));
        setItems(next);
        onChange?.({ ...data, items: next });
      }
      setToast({
        show: true,
        message: 'Toimenpidettä päivitettiin onnistuneesti',
        bg: "success",
      });
    } catch (err) {
      console.error(err);
      setToast({
        show: true,
        message: err.response?.data?.error || `Virhe päivittäessä ${field}`,
        bg: "danger",
      });
    }
  };

  const autoResize = (el) => {
  el.style.height = "auto";
  el.style.height = el.scrollHeight + "px";
};

  const toggleIncludePTS = (idx) => {
    const row = items[idx];
    const nextValue = !row.includeInPTS;
    updateItemField(idx, "includeInPTS", nextValue);
  };

  const removeItem = async (idx) => {
    const row = items[idx];
    try {
      await deleteToimenpide(row.id);
      const next = items.filter((_, i) => i !== idx);
      setItems(next);
      onChange?.({ ...data, items: next });
      setToast({
        show: true,
        message: "Toimenpide poistettu onnistuneesti",
        bg: "success",
      });
    } catch (err) {
      console.error(err);
      setToast({
        show: true,
        message: err.response?.data?.error || "Virhe poistaessa toimenpidettä",
        bg: "danger",
      });
    }
  };

  const addItem = async () => {
    const newItem = {
      "report_id": report_id,
      "kiinteisto_id": kiinteisto_id,
      "ptsproject_id": null,
      "kategoria": category,
      "alakategoria": subCategory,
      "merkittava": false,
      "valiton": false,
      "content": ""
    };
    
    try{

      const creationResponse = await createToimenpide(newItem)
      const newItemJson = creationResponse

      onChange?.({ ...data, items: [...items, newItemJson.data] });
      setItems([...items, newItemJson.data]);
      

      setToast({
        show: true,
        message: `Toimenpide luotu onnistuneesti`,
        bg: "success",
      });

    }catch(err){

      console.error(err);
      setToast({
        show: true,
        message: `Virhe luotaessa toimenpidettä: ${err.response?.data?.error}`,
        bg: "danger",
      });
    }
  };

  return (
    <div key={blockPath} className="p-3 bg-light border rounded">
      <ToastMessage show={toast.show} message={toast.message} bg={toast.bg} onClose={() => setToast({ ...toast, show: false })} />

      {/* Category & Subcategory */}
      <div className="row g-2 mb-3 align-items-center">
        <div className="col-auto d-flex align-items-center gap-2">
          <label className="form-label fw-bold mb-0">Kategoria</label>
          <select className="form-select form-select-sm" value={category || ""} onChange={(e) => { updateMainCategory(e.target.value); setSubCategory(null); }}>
            <option value="">Kaikki</option>
            {mainCategories.filter(c => c !== "Ei kategoriaa").map(cat => (<option key={cat} value={cat}>{cat}</option>))}
          </select>
        </div>
        {category && (
          <div className="col-auto d-flex flex-wrap gap-1">
            <label className="form-label fw-bold mb-0">Aliluokka</label>
            <button className={`btn btn-sm ${!subCategory ? "btn-primary" : "btn-outline-secondary"}`} onClick={() => setSubCategory(null)}>Kaikki</button>
            {subCategories.map(sub => (
              <button key={sub} className={`btn btn-sm ${subCategory === sub ? "btn-primary" : "btn-outline-secondary"}`} onClick={() =>  updateMainSubcategory(sub)}>{sub}</button>
            ))}
          </div>
        )}
      </div>

      {/* Toimenpiteet */}
      <div className="list-group mb-2">
        {items.length === 0 && <p className="text-muted">Ei toimenpiteitä valitulle kategorialle.</p>}
        {items.map((row, i) => (
          <div key={row.id} className="list-group-item mb-2 p-3 rounded shadow-sm">
            <textarea
              value={row.content}
              onChange={(e) => {
                const next = items.map((it, idx) =>
                  idx === i ? { ...it, content: e.target.value } : it
                );
                setItems(next);
                autoResize(e.target);
              }}

              onBlur={(e) => {
                updateItemField(i, "content", e.target.value);
              }}
              placeholder="Kirjoita toimenpide..."
              className="form-control mb-2"
              style={{
                fontFamily: "Lato, sans-serif",
                fontSize: "1.1rem",
                lineHeight: "1.3",
                padding: "0.5rem 0.5rem",
                resize: "none",
                overflow: "hidden",
                minHeight: "1.2em",
                width: "100%",
                whiteSpace: "pre-wrap",
                wordWrap: "break-word",
              }}
            />
            <div className="d-flex flex-wrap gap-2 align-items-center">
              <select className="form-select form-select-sm" value={row.kategoria} onChange={(e) => updateItemField(i, "kategoria", e.target.value)}>
                {mainCategories.map(cat => <option key={cat}>{cat}</option>)}
              </select>
              <select className="form-select form-select-sm" value={row.alakategoria} onChange={(e) => updateItemField(i, "alakategoria", e.target.value)}>
                {(TOIMENPIDE_CATEGORIES[row.kategoria] || []).map(sub => <option key={sub}>{sub}</option>)}
              </select>
              <div className="form-check form-check-inline">
                <input className="form-check-input" type="checkbox" checked={row.merkittava} onChange={(e) => updateItemField(i, "merkittava", e.target.checked)} />
                <label className="form-check-label">Merkittävä</label>
              </div>
              <div className="form-check form-check-inline">
                <input className="form-check-input" type="checkbox" checked={row.valiton} onChange={(e) => updateItemField(i, "valiton", e.target.checked)} />
                <label className="form-check-label">Välitön</label>
              </div>
              <button className={`btn btn-sm ${row.includeInPTS ? "btn-success" : "btn-outline-primary"}`} onClick={() => toggleIncludePTS(i)}>
                {row.includeInPTS ? "✓ PTS lisätty" : "➕ Lisää PTS"}
              </button>
              <button className="btn btn-outline-danger btn-sm" onClick={() => setConfirmModal({ show: true, rowIndex: i })}>Poista</button>
            </div>
          </div>
        ))}
      </div>

      <div className="text-end">
        <button className="btn btn-outline-secondary btn-sm" onClick={addItem}>+ lisää toimenpide</button>
      </div>

      {/* Confirm Modal */}
      <ConfirmModal
        show={confirmModal?.show}
        title="Poista rivi"
        message="Haluatko varmasti poistaa tämän toimenpiteen?"
        confirmText="Poista"
        cancelText="Peruuta"
        confirmVariant="danger"
        onClose={() => setConfirmModal({ show: false, rowIndex: null })}
        onConfirm={() => {
          if (confirmModal?.rowIndex != null) {
            removeItem(confirmModal.rowIndex);
            setConfirmModal({ show: false, rowIndex: null });
          }
        }}
      />
    </div>
  );
}